import styled from 'styled-components';
import { deviceLess } from '_constants/DEVICES';
import { RAIL_WIDTH, RAIL_COLLAPSED_WIDTH } from 'modules/Navigation/Rail/styles';
import { TOP_BAR_HEIGHT } from 'modules/Navigation/TopBar/styles';

export const HeaderContainer = styled.div`
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

/* The media-export bar has to survive scrolling: it appears while the user keeps working through a long
   gallery, and as a plain static child of a 100vh wrapper it sat at the very top of the document — out of
   view as soon as the page was scrolled at all, and in the new UI behind the fixed top bar. Sticky to the
   top of the content area instead, which in the new UI is exactly under that bar (the wrapper is padded by
   TOP_BAR_HEIGHT). z-index stays below the top bar's 70 so it can never cover the nav. */
export const StickyProgress = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  /* Opaque: content scrolls underneath it. */
  background: #f7f2f0;
`;

export const BodyContainer = styled.main`
  flex-grow: 1;
  padding-bottom: 100px;
`;

export const FooterContainer = styled.div`
  min-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f7f2f0;

  @media ${deviceLess.tableView} {
    /* Rail/top-bar offset only applies to the new UI; the old Header renders full-width. */
    padding-top: ${({ $newUi }) => ($newUi ? `${TOP_BAR_HEIGHT}px` : 0)};
    padding-left: ${({ $newUi, $isAuthenticated, $railCollapsed }) => {
      if (!$newUi || !$isAuthenticated) return 0;
      return $railCollapsed ? `${RAIL_COLLAPSED_WIDTH}px` : `${RAIL_WIDTH}px`;
    }};
    transition: padding-left 120ms ease;
  }

  @media print {
    html,
    body {
      overflow: hidden;
    }

    .leaflet-control-layers,
    .leaflet-control-zoom {
      display: none;
    }

    .turn-by-tyrn {
      display: flex;
    }

    .custom-retailer-marker {
      color: #0073ff !important;
    }

    body * {
      visibility: hidden;
    }

    .leaflet-routing-collapse-btn {
      visibility: hidden;
    }

    #map,
    #routing-instructions {
      visibility: visible;
      position: relative;
    }

    #map {
      width: 665px;
      break-after: always;
    }

    .routing-wrapper {
      margin-left: 0;
    }

    #routing-instructions {
      max-width: 665px;
      height: 100%;
      .leaflet-routing-container {
        width: 95vw;
        background-color: white;
        border-radius: none;
        box-shadow: none;
        padding: 0;
        margin-bottom: 0;
        font-size: 16px;

        .leaflet-routing-alt-minimized {
          display: none;
        }
      }
      break-before: always;
    }

    .no-print {
      display: none !important;
    }
  }
`;
